import React, {Component} from 'react';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import {connectedRouterRedirect} from 'redux-auth-wrapper/history4/redirect';
import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';
import jwt_decode from 'jwt-decode';
import {hasEntityRole} from 'common/utils';

function isTokenValid(state) {
  if (state.auth.token === null || state.auth.token === undefined) {
    return false;
  }
  var token = null;
  token = state.auth.token;
  var current_time = Date.now() / 1000;
  return token.exp < current_time ? false : true;
}
const locationHelper = locationHelperBuilder({});

const userIsAuthenticatedDefaults = {
  authenticatedSelector: (state) => isTokenValid(state),
  authenticatingSelector: (state) => state.auth.loading,
};

export const userIsAuthenticated = connectedAuthWrapper(userIsAuthenticatedDefaults);

// export const userIsAuthorizedForEntity = ( Component, FailureComponent, entityTypeId, entityId, roleId) => {
//       const role = '^' + entityTypeId + ':' + entityId + ':' + (roleId ? roleId : '.*') + '$';
//       return connectedAuthWrapper({
//         authenticatedSelector: state => hasEntityRole(state, role),
//         FailureComponent
//       })(Component);
// };

export const userIsAuthorizedForPathEntity = (
  Component,
  FailureComponent,
  entityTypeId,
  pathEntityKey,
  roleId
) => {
  return ({match}) => {
    const role = `^${entityTypeId}:${match.params[pathEntityKey]}:${
      roleId ? roleId : '.*'
    }$`;
    const Hoc = connectedAuthWrapper({
      authenticatedSelector: (state) => hasEntityRole(state, role),
      FailureComponent,
    })(Component);
    return <Hoc match={match} />;
  };
};

export const userIsAuthenticatedRedir = connectedRouterRedirect({
  ...userIsAuthenticatedDefaults,
  redirectPath: '/login',
});

const userIsNotAuthenticatedDefaults = {
  authenticatedSelector: (state) => !isTokenValid(state),
};

export const userIsNotAuthenticated = connectedAuthWrapper(
  userIsNotAuthenticatedDefaults
);

export const userIsNotAuthenticatedRedir = connectedRouterRedirect({
  ...userIsNotAuthenticatedDefaults,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/login',
  allowRedirectBack: false,
});
